/*
 * @Author: 李朋飞
 * @Date: 2021-07-15 19:02:38
 * @LastEditTime: 2021-09-06 10:33:49
 * @Description: 用来管理操作数据的方法， 用于mutations和actions通信
 */

export const GET_MEN_LIST = 'GET_MEN_LIST';
export const ROUTER_LIST_NEW = 'ROUTER_LIST_NEW';
export const MY_INFO = 'MY_INFO'; // 我的信息
export const CHAT_UNREAD = 'CHAT_UNREAD'; // 未读数
export const USER_ID = 'USER_ID'; // 当前聊天人
export const CONVERSATION_LIST = 'CONVERSATION_LIST'; // 会话列表
export const HISTORY_MESSAGE = 'HISTORY_MESSAGE'; // 消息列表
export const UPDATE_CHAT_HISTORY = 'UPDATE_CHAT_HISTORY'; // 更新消息列表
export const UPDATE_CHAT_HISTORY_FILTER = 'UPDATE_CHAT_HISTORY_FILTER'; // 更新消息列表
export const USER_IS_TYPING = 'USER_IS_TYPING'; // 用户正在输入
export const SELECT_CONVERSATION_LIST = 'SELECT_CONVERSATION_LIST'; // 搜索会话列表
export const MSG_RECEIPTS = 'MSG_RECEIPTS'; // MSG_RECEIPTS
export const UPDATE_CONVERSATION_LIST = 'UPDATE_CONVERSATION_LIST'; // 更新会话列表
export const SET_MENU_LIST = 'SET_MENU_LIST'; // 更新菜单
export const CHAT_NOTION_MSG = 'CHAT_NOTION_MSG';
export const UPDATE_DELETE_USERID = 'UPDATE_DELETE_USERID'; // 更新删除的userid
export const CHECK_CONVERSATION_LIST = 'CHECK_CONVERSATION_LIST'; // 全选更新会话列表


// WEBPACK FOOTER //
// ./src/store/mutation-types.js